const colors = {
    CHART_COLORS: null,
    DEFAULT_COLORS: ["#000000", "#000000", "#000000", "#000000", "#000000"],
    APP_COLORS: {
        Blue: ["#1ABCEC", "#63D0F1", "#90DEF4", "#D3F1FB"],
        Red: ["#DD7379", "#E89DA0", "#EEB9BB", "#F8E3E4"],
        Orange: ["#FFCE68", "#FFDD92", "#FFE6B0", "#FFF6DF"],
        Green: ["#00A187", "#55BDAA", "#87CFC3", "#CFECE7"],
        Purple: ["#F588F8", "#F8ACFA", "#FAC4FB", "#FDE7FD"],
        DarkGreen: ["#A7CD77", "#C1DC9E", "#D3E6B9", "#EDF5E2"],
        DarkRed: ["#E97F38", "#EFA56F", "#F4BF98", "#FAE5D6"],
        DarkBlue: ["#277BB4", "#67A3CA", "#92BDD8", "#D4E4F0"],
        Gray: ["#BDC3C7", "#D1D5D8", "#DEE1E3", "#F2F3F4"]
    },
    CHART_COLORS: {
        Blue: ["#cbecf7", "#0f65b1"],
        Red: ["#DD7379", "#0f65b1"],
        Orange: ["#FFCE68", "#0f65b1"],
        Green: ["#00A187", "#0f65b1"],
        Purple: ["#d7c5f6", "#0f65b1"],
        DarkGreen: ["#A7CD77", "#0f65b1"],
        DarkRed: ["#E97F38", "#0f65b1"],
        DarkBlue: ["#277BB4", "#0f65b1"],
        All: ["#1ABCEC", "#63D0F1", "#DD7379", "#E89DA0", "#FFCE68", "#FFDD92", "#00A187", "#55BDAA", "#F588F8",
            "#F8ACFA", "#A7CD77", "#C1DC9E", "#E97F38", "#EFA56F", "#277BB4", "#67A3CA", "#1ABCEC", "#63D0F1",
            "#DD7379", "#E89DA0", "#FFCE68", "#FFDD92", "#00A187", "#55BDAA", "#F588F8", "#F8ACFA", "#A7CD77",
            "#C1DC9E", "#E97F38", "#EFA56F", "#277BB4", "#67A3CA"],
    },
    BAR_CHART_COLORS: {
        Blue: ['#d7c5f6', '#a4e0f8', '#4f83c0', '#8ce4c9', '#dcee86'],
        Top5Apps: ['#468966', '#32A3AD', '#D7D287', '#FFB03B', '#D46744'],
        Top5VMs: ['#644290', '#6464AB', '#647DB9', '#6496C2', '#66B0C6'],
    },
    DONUT_COLORS: {
        Critical: ["#b291f9", "#4f83c0", "#aee2f9", "#66ddb8"],
        Events: ["#2DAD89", "#D55B4E", "#EECD56"],
        Jobs: ["#2DAD89", "#D55B4E", "#3498DB", "#F08CCD"],
        Percent: ["#009e73", "#d94061", "#f7f7f7"],
        Policies: ["#0099ff", "#d94061"],
        VmUsers: ["rgb(97,222,184)", "rgb(209,237,77)", "rgb(77,130,194)", "rgb(213,91,78)"],
        TargetDetails: ["rgb(0,123,123)", "rgb(50,163,173)", "rgb(78,203,213)", "rgb(168,227,233)", "rgb(221,221,221)"],
        TargetDonut: ["#9ABEEE", "#0069FF"]
    },
    CHART_LIMIT_EXCEEDED_COLOR: "BDC3C7",
    CP: {
        COLORS_MAP: {
            BLACK: "#000000",
            WHITE: "#ffffff",
            GRAY: "#dbdfe1",
            RED: "#cc6164",
            GRAY_1: "#89949b",
            GRAY_2: "#edeff0",
            GRAY_3: "#a7b4bb",
            BLUE: "#52c6e3",
            GRAY_4: "#454c53",
            GRAY_5: "#c4c9cd",
            YELLOW: "#ffce68"
        },
        CHART_FILL_COLORS: ["#1ABCEC", "#DD7379", "#FFCE68", "#00A187"],
        CHART_STROKE_COLORS: ["#ada5e0", "#88cddb", "#a3dfca", "#a6daa6"]
    },
    FS: {
        COLORS_MAP: {
            RED: "#cf6a6d",
            BLUE: "#26bbf0",
            GREEN: "#6eb17b",
            YELLOW: "#ffd055"
        }
    },
    EB: {
        DEFAULT_COLOR_HEX: "26BBF0",
        CIRCLE_CHECK_COLOR: "#ffffff",
        CIRCLE_HIGHLIGHT_COLOR: "#cccccc",
        Critical: "CC6164",
        Warning: "FFBC0B",
        Good: "0DC984",
        Unknown: "C4C9CD"
    },
    PERCENTAGE_BAR: '#0099ff',
    GRAPH_COLORS: {
        events: [{ strokeColor: "#009e73" }, { strokeColor: "#ffb50f" }, { strokeColor: "#d94061" }],
        jobs: [{ strokeColor: "#009e73" }, { strokeColor: "#ffb50f" }, { strokeColor: "#d94061" }, { strokeColor: "#0099ff" }],
        backups: [{ strokeColor: "#009e73" }]
    }
};

const chartColorMap = {
    'mbps': colors.CHART_COLORS.Blue,
    'kbps': colors.CHART_COLORS.Orange,
    'iops': colors.CHART_COLORS.DarkGreen,
    'cpu': colors.CHART_COLORS.Purple,
    'latency': colors.CHART_COLORS.Red
};

const donutColorMap = {
    'critical': colors.DONUT_COLORS.Critical,
    'events': colors.DONUT_COLORS.Events,
    'jobs': colors.DONUT_COLORS.Jobs,
    'percent': colors.DONUT_COLORS.Percent,
    'policies': colors.DONUT_COLORS.Policies,
    'vm-users': colors.DONUT_COLORS.VmUsers,
    'target-details': colors.DONUT_COLORS.TargetDetails,
    'target-donut': colors.DONUT_COLORS.TargetDonut
};

class Style {
    constructor() {
        this.colors = colors;
    }

    getAllColors() {
        return this.colors;
    }

    getChartColors() {
        return this.colors.CHART_COLORS;
    }

    getAllChartColors() {
        return this.colors.CHART_COLORS.All;
    }

    getDonutColors() {
        return this.colors.DONUT_COLORS;
    }

    getAppColors() {
        return this.colors.APP_COLORS;
    }

    getChartColor(type) {
        return chartColorMap[type];
    }

    getDonutColor(type) {
        return donutColorMap[type];
    }

    getPercentageCircleBarColor() {
        return this.colors.PERCENTAGE_BAR;
    }

    getBarChartColor() {
        return colors.BAR_CHART_COLORS.Blue;
    }

    getBarChartTop5AppsColors() {
        return colors.BAR_CHART_COLORS.Top5Apps;
    }

    getBarChartTop5VMsColors() {
        return colors.BAR_CHART_COLORS.Top5VMs;
    }

    getGraphColors(type) {
        return this.colors.GRAPH_COLORS[type];
    }
}

module.exports = Style;


// WEBPACK FOOTER //
// ./src/azurebackup/services/style.service.js